import HomeMainContentThreadsRail from '@/components/MainContentLayout/HomeMainContentThreadsRail'
import ActionButtonRow from './components/ActionButtonRow'
import ThreadsSection from './components/ThreadsSection'
import { NoteEdit24Regular } from '@/components/Icon'

export function renderSecondaryNavThreadSection(section, ctx) {
  const key = `${section.type}-${ctx.index}`

  if (section.type === 'homeThreadsRail') {
    return (
      <HomeMainContentThreadsRail
        key={key}
        threads={ctx.threads}
        selectedThreadId={ctx.selectedThreadId}
        onSelectThread={ctx.onThreadSelect}
        onThreadMenuAction={ctx.onThreadMenuAction}
        onRenameThread={ctx.onRenameThread}
      />
    )
  }

  if (section.type === 'newChatAction') {
    return (
      <ActionButtonRow
        key={key}
        Icon={NoteEdit24Regular}
        label={section.label ?? 'New Chat'}
        onClick={ctx.onNewChat}
      />
    )
  }

  if (section.type === 'threadsList') {
    return (
      <ThreadsSection
        key={key}
        threads={ctx.threads}
        selectedThreadId={ctx.selectedThreadId}
        onSelectThread={ctx.onThreadSelect}
        onThreadMenuAction={ctx.onThreadMenuAction}
        onRenameThread={ctx.onRenameThread}
      />
    )
  }

  return null
}
